import { Theme } from '@material-ui/core';
import React, { useState } from 'react';
import { TypedUseSelectorHook, useSelector as useReduxSelector } from 'react-redux';
import Layout from '../../components/Layout';
import { RootState } from '../../redux/reducers';
import { useContrat } from './hooks/selectors';
import ComptePageContent from './Content';

interface Props {
  classes?: any;
}
export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;
const ComptePage = (props: Props) => {
  const { classes } = props;

  const { authenticated } = useContrat();

  // Recuperation du Theme courant depuis le ThemeProvider
  const [theme, setTheme] = useState<Theme>();

  return (
    <Layout authenticated={authenticated} passTheme={setTheme}>
      <ComptePageContent theme={theme}></ComptePageContent>
    </Layout>
  );
};

export default ComptePage;
